import {
  campaignImage,
  Content,
  PageShell,
  PrizeArt,
  SparkleIcon
} from './shared';
import SquadBuilder from './SquadBuilder';
import HARDCODED_MYSTERY_PRIZES from './revealMysteryPrizes';
import {
  Fade,
  Glow,
  Headline,
  Hero,
  HeroBg,
  HeroCopy,
  HeroStage,
  MoreRow,
  MysteryArt,
  MysteryMark,
  PrizeCardBox,
  PrizeCopy,
  PrizeGrid,
  PrizeHeading,
  PrizeName,
  PrizePanel,
  PrizeSub,
  PrizeTitle,
  Subhead,
  TimerBlock,
  TimerBox,
  TimerLabel,
  TimerSep,
  TimerWrap
} from './revealScreenStyles';
import { padCountdownUnit, useRevealCountdown } from './useRevealCountdown';
import type { CampaignState, PrizeCard, ReferralSquadData } from './types';

type RevealScreenProps = {
  data: CampaignState['reveal'];
  squad: CampaignState['squad'];
  onSquadUpdate?: (data: ReferralSquadData) => void;
};

const RevealScreen = ({ data, squad, onSquadUpdate }: RevealScreenProps) => {
  const remaining = useRevealCountdown(data.endsAt);
  const showTimer = Boolean(data.endsAt && remaining);

  return (
    <PageShell>
      <Hero>
        <HeroStage>
          <HeroBg src={campaignImage('reveal-bg.png')} alt="" />
          <Fade />
        </HeroStage>
        <HeroCopy>
          <Subhead>iPad bhi. Hunter bhi. Europe bhi. Haan, PS5 bhi.</Subhead>
          <Headline
            src={campaignImage('reveal-headline.png')}
            alt="We are giving you everything and more"
          />
        </HeroCopy>
      </Hero>
      {showTimer && remaining ? (
        <TimerWrap>
          <TimerBlock>
            <TimerBox>{padCountdownUnit(remaining.hours)}</TimerBox>
            <TimerLabel>Hours</TimerLabel>
          </TimerBlock>
          <TimerSep>:</TimerSep>
          <TimerBlock>
            <TimerBox>{padCountdownUnit(remaining.minutes)}</TimerBox>
            <TimerLabel>Minutes</TimerLabel>
          </TimerBlock>
          <TimerSep>:</TimerSep>
          <TimerBlock>
            <TimerBox>{padCountdownUnit(remaining.seconds)}</TimerBox>
            <TimerLabel>Seconds</TimerLabel>
          </TimerBlock>
        </TimerWrap>
      ) : null}
      <Content $afterHero="reveal">
        <PrizePanel>
          <PrizeHeading>
            <SparkleIcon />
            <PrizeTitle>Get ready to win all of these</PrizeTitle>
            <SparkleIcon />
          </PrizeHeading>
          <PrizeGrid>
            {data.prizes.map((prize: PrizeCard) => (
              <PrizeCardBox key={prize.id}>
                {prize.imageUrl || prize.prizeKey ? (
                  <PrizeArt
                    src={prize.imageUrl}
                    prizeKey={prize.prizeKey}
                    tall
                  />
                ) : null}
                <PrizeCopy>
                  <PrizeName>{prize.title}</PrizeName>
                  <PrizeSub>{prize.subtitle}</PrizeSub>
                </PrizeCopy>
              </PrizeCardBox>
            ))}
            {HARDCODED_MYSTERY_PRIZES.map((prize: PrizeCard) => (
              <PrizeCardBox key={prize.id}>
                <MysteryArt>
                  <Glow src={campaignImage('question-glow.svg')} alt="" />
                  <MysteryMark>?</MysteryMark>
                </MysteryArt>
                <PrizeCopy>
                  <PrizeName>{prize.title}</PrizeName>
                  <PrizeSub>{prize.subtitle}</PrizeSub>
                </PrizeCopy>
              </PrizeCardBox>
            ))}
          </PrizeGrid>
          <MoreRow>and many more...</MoreRow>
        </PrizePanel>
        <SquadBuilder
          members={squad.members}
          extraCount={squad.extraCount}
          promotionPart={3}
          onSquadUpdate={onSquadUpdate}
        />
      </Content>
    </PageShell>
  );
};

export default RevealScreen;
